<template>
    <div class="garanties-list">
        <div class="clients__title">
            Garanties souscrites
        </div>

        <GarantiesFilter @submit="onFilterChanged"/>

        <template v-if="isLoading">
            <Preloader />
        </template>
        <template v-else>
            <div class="clients__table">
                <template v-if="garanties.data.length > 0">
                    <div class="clients__table__item">
                        <div class="clients__table__item--cell">Date</div>
                        <div class="clients__table__item--cell" v-if="isSarrutAdmin">Nom du Conseiller</div>
                        <div class="clients__table__item--cell" v-else>Nom</div>
                        <div class="clients__table__item--cell" v-if="representative_id">Garantie souscrite</div>
                        <div class="clients__table__item--cell" v-else>Garantie souscrite</div>
                        <div class="clients__table__item--cell">Prix</div>
                        <div class="clients__table__item--cell">Statut</div>
                        <div class="clients__table__item--cell">Bon</div>
<!--                        <div class="clients__table__item&#45;&#45;cell">Contrat</div>-->
                    </div>
                    <div class="clients__table__item" v-for='garanty in garanties.data'>
                        <div class="clients__table__item--cell">{{parseDate(garanty)}}</div>
                      <div class="clients__table__item--cell" v-if="isSarrutAdmin">{{garanty.conseiller}}</div>
                        <div class="clients__table__item--cell" v-else>{{parseFullName(garanty)}}</div>
                        <div class="clients__table__item--cell">{{parseTypeGaranty(garanty)}}</div>
                        <div class="clients__table__item--cell">{{parsePrice(garanty)}}</div>
                        <div class="clients__table__item--cell">{{parseStatusGaranty(garanty)}}</div>
                        <div class="clients__table__item--cell icon-cell">
                            <font-awesome-icon prefix="fas" icon="file-pdf" @click="show_pdf(garanty.id)"/>
                        </div>
<!--                        <div class="clients__table__item&#45;&#45;cell icon-cell">-->
<!--                            <font-awesome-icon prefix="fas" icon="file-pdf" @click="preview_pdf('garantie/confirmation-pdf/' + garanty.id, '&show_type=stream')"/>-->
<!--                        </div>-->
                    </div>
                </template>
                <template v-else>
                    <div class="subscribes-empty">Il n'y a aucun client pour ce type de garantie à ce jour.</div>
                </template>

            </div>

            <pagination v-if="representative_id" :data="garanties" @pagination-change-page="getRepresentativeGaranties" :limit="10"></pagination>
            <pagination v-else :data="garanties" @pagination-change-page="getGaranties" :limit="10"></pagination>
        </template>
    </div>
</template>

<script>
    import GarantiesFilter from '@/components/GarantiesSouscrites/GarantiesFilter'
    import Preloader from '@/components/Preloader'
    import pdfPreviewMixin from '../../mixins/pdfPreviewMixin';

    export default {
        name: "GarantiesList",
        components: {GarantiesFilter, Preloader},
        mixins: [pdfPreviewMixin],
        data() {
            return {
                garanties: {
                    data: []
                },
                filterParams: {
                   pdf: 1,
                },
                sortParams: {
                    sort: 'id|desc',

                },
                isLoading: false,
            }
        },
        computed: {
            mechanic_id() {
                return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
            },
            representative_id() {
              return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
            },
            isSarrutAdmin() {
              return this.$store.getters.isSarrutAdmin;
            },
            isSagaAdmin() {
              return this.$store.getters.isSagaAdmin;
            }
        },
        watch: {
            'mechanic_id': function() {
                this.getGaranties();
            },
            'representative_id': function() {
              this.getRepresentativeGaranties();
            }
        },
        methods: {
            isDealer() {
              return this.$store.getters.isDealer;
            },
            isRepresentative() {
              return this.$store.getters.isRepresentative;
            },
            isGarden() {
              return this.$store.getters.isGarden;
            },
            isSagaAdmin() {
              return this.$store.getters.isSagaAdmin;
            },
            parseDate(garanty) {
                if (garanty && garanty.created_at) {
                    let day = garanty.datesParse.day_created,
                        month = garanty.datesParse.month_created,
                        year = garanty.datesParse.year_created;
                    return day + "/" + month + '/' + year;
                }

                return ' - ';
            },
            parsePrice(garanty) {
              if (this.isDealer()) {
                let amount = 0;
                if (+garanty.assistance_price > 0) {
                  if (garanty.status == 'Credited')
                    amount += -(garanty.price + garanty.assistance_price);
                  else
                    amount += +(garanty.price + garanty.assistance_price);
                }
                else {
                  if (garanty.status == 'Credited')
                    amount = -garanty.price || 0;
                  else
                    amount = garanty.price || 0;
                }
                return this.roundEURWithoutSymbol(amount) + ' €';
              }
              if (garanty.status == 'Credited')
                return (garanty && garanty.price) ? '-' + this.roundEURWithoutSymbol(garanty.price) + ' €' : ' - ';
              else
                return (garanty && garanty.price) ? this.roundEURWithoutSymbol(garanty.price) + ' €' : ' - ';
            },
            parseFullName(garanty) {
              if (this.isRepresentative() && !this.isSagaAdmin) {
                return (garanty && garanty.mechanic && garanty.mechanic.garage) ? garanty.mechanic.garage : ' - ';
              }
              else {
                  if (garanty.client && (+garanty.client.civility === 3)) {
                      return garanty.client.name_of_signatory || '-';
                  }
                return (garanty && garanty.client) ? garanty.client.first_name + ' ' + garanty.client.last_name : ' - ';
              }
            },
            parseTypeGaranty(garanty) {
              if (this.isGarden()) {
                if (garanty && garanty.category) {
                  switch (+garanty.category) {
                    case 1:
                      return 'Tondeuse, Robot';
                      break;
                    case 2:
                      return 'Tronçonneuse';
                      break;
                    case 3:
                      return 'Taille-Haie';
                      break;
                    case 4:
                      return 'Débrousailleuse';
                      break;
                    case 5:
                      return 'Elagueuse';
                      break;
                    case 6:
                      return 'Autres';
                      break;
                  }
                }
              }
              else {
                if (garanty.garantie_name) {
                  return garanty.garantie_name;
                }
                else if (garanty && garanty.category) {
                  switch (+garanty.category)
                  {
                    case 2: return 'Auto'; break;
                    case 3: return 'Moto'; break;
                    case 1: return 'Camping car'; break;
                  }
                }
              }

                return '';
            },
            parseStatusGaranty(garanty) {
              if (garanty && garanty.status) {
                switch (garanty.status) {
                  case 'Active':
                    return 'Valide';
                    break;
                  case 'Inactive':
                    return 'Annulée';
                    break;
                  case 'Expired':
                    return 'Echue';
                    break;
                  case 'Credited':
                    return 'Sans Effet';
                    break;
                }
              }
              return '';
            },
            onFilterChanged(filterParams) {
                this.filterParams = filterParams;
                this.$nextTick(() => {
                    if(this.representative_id) {
                      this.getRepresentativeGaranties();
                    }
                    else {
                      this.getGaranties();
                    }
                });
            },
            getGaranties(page = 1) {
                this.isLoading = true;
                let url = (this.isDealer()) ? 'garantie/dealer-search?page=' + page : 'garantie/search?page=' + page,
                    data = {
                        mechanic_id: this.mechanic_id,
                        ...this.filterParams,
                        ...this.sortParams
                    };
                this.apiGet(url, data)
                    .then(response => {
                        this.isLoading = false;
                        this.garanties = response.data;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    })
            },
            getRepresentativeGaranties(page = 1) {
                this.isLoading = true;
                let url = 'garantie/representative-search?page=' + page,
                    data = {
                        representative_id: this.representative_id,
                        ...this.filterParams,
                        ...this.sortParams
                    };
                this.apiGet(url, data)
                    .then(response => {
                        this.isLoading = false;
                        this.garanties = response.data;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log(error);
                    })
            },
        },
        mounted() {
          if (this.representative_id) {
            this.getRepresentativeGaranties();
          }
          else {
            this.getGaranties();
          }
        }

    }
</script>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/GarantiesList.vue